import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Col, Modal, Button } from 'react-bootstrap'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import InputText from '../../commons/form/InputText'
import InputNumber from '../../commons/form/InputNumber'
import InputCheckBox from '../../commons/form/InputCheckBox'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

const DEFAULT_MAX_PERCENTAGE = 100

class DossierStageModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      warnings: {
        visibleToProcessingAgency: false,
        maxDays: false,
        percentToWarn: false,
        permissionResponsableId: false,
        permissionToNotificationId: false
      }
    }
  }

  submitDossierStage (values) {
    const dossierStageUpdatedLanguages = []
    Object.keys(values).map(item => {
      if (/lang[0-9]/.test(item)) {
        dossierStageUpdatedLanguages.push(values[item])
      }
    })

    var dossierStageFieldsToSubmit = {}
    dossierStageFieldsToSubmit.dossierStageId = this.props.dossierStageId
    dossierStageFieldsToSubmit.dossierStageLanguages = dossierStageUpdatedLanguages
    dossierStageFieldsToSubmit.maxDays = values.maxDays
    dossierStageFieldsToSubmit.percentToWarn = values.percentToWarn
    dossierStageFieldsToSubmit.permissionResponsableId = values.permissionResponsableId
    dossierStageFieldsToSubmit.permissionToNotificationId = values.permissionToNotificationId
    dossierStageFieldsToSubmit.visibleToProcessingAgency = values.visibleToProcessingAgency
    dossierStageFieldsToSubmit.dossierSubTypeId = this.props.dossierStageFields?.dossierSubTypeId
    dossierStageFieldsToSubmit.warnings = this.state.warnings

    this.props.actions.submitDossierStage(dossierStageFieldsToSubmit, this.props.dossierStageId)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.showDossierStageModal !== this.props.showDossierStageModal &&
      this.props.showDossierStageModal === true) {
      this.props.initialize({ ...this.props.dossierStageFields })
      this.setState({
        warnings: {
          visibleToProcessingAgency: false,
          maxDays: false,
          percentToWarn: false,
          permissionResponsableId: false,
          permissionToNotificationId: false
        }
      })
    }

    if (prevProps.dossierStageFields?.dossierStageLanguages !== this.props.dossierStageFields?.dossierStageLanguages) {
      this.props.languageList.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const nextTranslation = this.props.dossierStageFields?.dossierStageLanguages
          .find((faqSection) => faqSection.languageId === language.languageId)
        if (nextTranslation && nextTranslation !== undefined) {
          this.props.change(`lang${language.languageId}.name`, nextTranslation.name)
          this.props.change(`lang${language.languageId}.description`, nextTranslation.description)
        }
      })
    }
  }

  componentDidMount () {
    this.props.actions.fetchPermissionCombo()
  }

  onChange (value, propName) {
    let valueToCompare = !isNaN(value) ? `${value}` : value
    let raiseWarning = this.props.dossierStageFields[propName]?.toString() !== valueToCompare
    this.setState({ warnings: { ...this.state.warnings, [propName]: raiseWarning } })
  }

  render () {
    const {
      t,
      showDossierStageModal,
      handleSubmit,
      languageList = [],
      combos: {
        permissionCombo
      },
      actions: {
        closeEditDossierStageModal
      }
    } = this.props
    const tKey = 'MASTERS.DOSSIER_STAGES_MASTERS.'

    return (
      <Modal id="dossierStageMasterModal" show={showDossierStageModal} onHide={closeEditDossierStageModal} className="_nf" backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}DOSSIER_STAGE_DETAIL`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDossierStage.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <SimpleTablePage
              customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />

            <div className="search-form">
              <Field
                component={InputNumber}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name={'maxDays'}
                id={'maxDays'}
                placeholder ={t(`${tKey}MAX_DAYS`)}
                controlLabel={t(`${tKey}MAX_DAYS`)}
                valueKey="id"
                labelKey="value"
                onChange={(event, value) => this.onChange(value, 'maxDays')}
              />
              <Field
                component={InputNumber}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name={'percentToWarn'}
                id={'percentToWarn'}
                placeholder ={t(`${tKey}WARNING_PERCENTAGE`)}
                controlLabel={t(`${tKey}WARNING_PERCENTAGE`)}
                valueKey="id"
                labelKey="value"
                onChange={(event, value) => this.onChange(value, 'percentToWarn')}
                max={DEFAULT_MAX_PERCENTAGE}
              />
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name="permissionResponsableId"
                controlLabel={t(`${tKey}MANAGER_PERMISSION`)}
                placeholder={t(`${tKey}MANAGER_PERMISSION`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                childrenKey="children"
                options={permissionCombo}
                onChange={(event, value) => this.onChange(value, 'permissionResponsableId')}
              />
              <Field
                component={InputSelect}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name={'permissionToNotificationId'}
                controlLabel={t(`${tKey}NOTIFY_PERMISSION`)}
                placeholder={t(`${tKey}NOTIFY_PERMISSION`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                childrenKey="children"
                options={permissionCombo}
                onChange={(event, value) => this.onChange(value, 'permissionToNotificationId')}
              />
              <Field
                component={InputCheckBox}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                name={'visibleToProcessingAgency'}
                id={'visibleToProcessingAgency'}
                placeholder ={t(`${tKey}VISIBLE_PROCESSING_AGENCY`)}
                onChange={(event, value) => this.onChange(value, 'visibleToProcessingAgency')}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col className="flexInLine al-R" >
              <Button type="submit" className="_Btn new">
                {t('MASTERS.SAVE')}
              </Button>
              <Button
                id="role-modal-submit-button"
                className="_Btn cancel"
                type="reset"
                onClick={closeEditDossierStageModal}>
                {t('MASTERS.CANCEL')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  props.languageList.map(language => {
    errors[`lang${language.languageId}`] = {}
    if (values[`lang${language.languageId}`]) {
      if (!(values[`lang${language.languageId}`].name)) {
        errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      }
      if (!(values[`lang${language.languageId}`].description)) {
        errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
      }
    } else {
      errors[`lang${language.languageId}`].name = props.t('MASTERS.VALIDATION.NAME_REQUIRED')
      errors[`lang${language.languageId}`].description = props.t('MASTERS.VALIDATION.DESCRIPTION_REQUIRED')
    }
  })

  return errors
}

export default reduxForm({
  form: 'editDossierStageModal',
  validate
})(DossierStageModal)
